import { TDiffPart } from '../types';

export const tokenizeDiffText = (value: string): string[] => value.match(/\s+|[A-Za-z0-9]+|[^A-Za-z0-9\s]+/g) ?? [];

export const buildTokenDiff = (
  before: string,
  after: string,
): { afterParts: TDiffPart[]; beforeParts: TDiffPart[] } => {
  const beforeTokens = tokenizeDiffText(before);
  const afterTokens = tokenizeDiffText(after);
  const table = Array.from({ length: beforeTokens.length + 1 }, () =>
    Array.from({ length: afterTokens.length + 1 }, () => 0),
  );

  for (let beforeIndex = beforeTokens.length - 1; beforeIndex >= 0; beforeIndex -= 1) {
    for (let afterIndex = afterTokens.length - 1; afterIndex >= 0; afterIndex -= 1) {
      table[beforeIndex][afterIndex] =
        beforeTokens[beforeIndex] === afterTokens[afterIndex]
          ? table[beforeIndex + 1][afterIndex + 1] + 1
          : Math.max(table[beforeIndex + 1][afterIndex], table[beforeIndex][afterIndex + 1]);
    }
  }

  const beforeParts: TDiffPart[] = [];
  const afterParts: TDiffPart[] = [];
  let beforeIndex = 0;
  let afterIndex = 0;

  while (beforeIndex < beforeTokens.length || afterIndex < afterTokens.length) {
    if (
      beforeIndex < beforeTokens.length &&
      afterIndex < afterTokens.length &&
      beforeTokens[beforeIndex] === afterTokens[afterIndex]
    ) {
      beforeParts.push({ changed: false, text: beforeTokens[beforeIndex] });
      afterParts.push({ changed: false, text: afterTokens[afterIndex] });
      beforeIndex += 1;
      afterIndex += 1;
    } else if (
      afterIndex >= afterTokens.length ||
      (beforeIndex < beforeTokens.length && table[beforeIndex + 1][afterIndex] >= table[beforeIndex][afterIndex + 1])
    ) {
      beforeParts.push({ changed: true, text: beforeTokens[beforeIndex] });
      beforeIndex += 1;
    } else {
      afterParts.push({ changed: true, text: afterTokens[afterIndex] });
      afterIndex += 1;
    }
  }

  return { afterParts, beforeParts };
};
